import {
  ReportTable,
  ReportTableData,
  ReportTableHeader,
} from '../../../components/Table/types';
import {useLeadSumReportQuery, usePhaseReportsQuery} from 'api';
import React from 'react';

const useTableData = (): ReportTable => {
  const headers: ReportTableHeader[] = ['フェーズ', ''];
  const {data: {phaseReports = []} = {}} = usePhaseReportsQuery({});
  const {data: {leadSumReport = null} = {}} = useLeadSumReportQuery({});
  const sumReportData = React.useMemo(() => {
    if (!leadSumReport) {
      return;
    }
    return {
      label: leadSumReport.name,
      values: leadSumReport.values,
      callProps: {
        style: {
          borderBottom: 'double 3px var(--text-color-2)',
        },
      },
    };
  }, [leadSumReport]);

  const reportData = React.useMemo(() => {
    return phaseReports.map((report) => {
      return {
        label: report.name,
        values: report.values,
      };
    });
  }, [phaseReports]);

  const data: ReportTableData[] = [sumReportData, ...reportData].filter(
    Boolean,
  );

  return {
    data,
    headers,
  };
};

export default useTableData;
